import { PropsWithChildren, useContext, useEffect } from "react"
import { useNavigate } from "react-router"
import AdminUserContext from "../context/AdminUser"

const AdminAuthWrapper = ( { children }:Props ) => {

    const navigate = useNavigate()

    const { state: user } = useContext( AdminUserContext )

    useEffect( () => {
        if( !user ) navigate( '/admin/login' )
    }, [ user, navigate ])

    return children
}

interface Props extends PropsWithChildren<any>{ }

export default AdminAuthWrapper
